function WarningNavIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16">
      <path
        fill="#FF5630"
        fillRule="evenodd"
        d="M15.04 10.867l-5.113-8.48a2.287 2.287 0 00-3.853 0L.96 10.867a2 2 0 00-.033 2A2.247 2.247 0 002.887 14h10.227a2.247 2.247 0 001.96-1.107 2 2 0 00-.034-2.026zM8 11.333A.667.667 0 118 10a.667.667 0 010 1.333zm0-2a.667.667 0 00.667-.666V6a.667.667 0 00-1.333 0v2.667c0 .368.298.666.666.666z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

export default WarningNavIcon;
